import { useQueryClient, type QueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { RegistryItem } from "../types";

import { useAuth } from "@/context/auth-context";
import { EntityType } from "@/queries/folder-entities/types";
import { fetchSmartTableBootstrap } from "@/queries/smart-tables";
import { preloadSmartTablePage } from "@/routes/smart-table/loadSmartTablePage";

export const prefetchSmartTableNavigation = ({
  queryClient,
  userToken,
  workspaceId,
  tableId,
}: {
  queryClient: QueryClient;
  userToken: string;
  workspaceId: number;
  tableId: string;
}) => {
  preloadSmartTablePage();

  if (!userToken) {
    return;
  }

  void queryClient.prefetchQuery({
    queryKey: ["smart-tables", workspaceId, tableId, "bootstrap"],
    queryFn: () =>
      fetchSmartTableBootstrap({
        wid: workspaceId,
        tableId,
        userToken,
      }),
  });
};

export const useSmartTableNavigationPrefetch = ({
  item,
  workspaceId,
}: {
  item: RegistryItem;
  workspaceId: number;
}) => {
  const queryClient = useQueryClient();
  const userToken = useAuth()?.userToken ?? "";

  return useCallback(() => {
    if (item.type !== EntityType.SMART_TABLE) {
      return;
    }

    prefetchSmartTableNavigation({
      queryClient,
      userToken,
      workspaceId,
      tableId: String(item.id),
    });
  }, [item.id, item.type, queryClient, userToken, workspaceId]);
};
